export default class MovingEye {
  eye;
  constructor(eye) { 
    this.eye = eye;
    this.bindListeners();
  }

  bindListeners() { 
    document.addEventListener('mousemove', this.manageEyePosition.bind(this));
  }

  manageEyePosition(ev) { 
    let eyeOffset = this.offset(this.eye);
    if (ev.pageX < eyeOffset.left + (this.eye.clientWidth / 2)) {
      if (!this.eye.classList.contains('left')) {
        this.eye.classList.remove('right');
        this.eye.classList.add('left');
      }
    }
    else { 
      if (!this.eye.classList.contains('right')) {
        this.eye.classList.remove('left');
        this.eye.classList.add('right');
      }
    }
    if (ev.pageY < (eyeOffset.top + (this.eye.clientHeight / 2 ))) {
      if (!this.eye.classList.contains('top')) {
        this.eye.classList.remove('bottom');
        this.eye.classList.add('top');
      }
    }
    else { 
      if (!this.eye.classList.contains('bottom')) {
        this.eye.classList.remove('top');
        this.eye.classList.add('bottom');
      }
    }
  }

  removeActiveClass() { 

  }

  offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
  }
}


// WEBPACK FOOTER //
// ./ui/assets/js/MovingEye/MovingEye.js